// extracted by mini-css-extract-plugin
export default {"filtroAncho":"unidades_filtroAncho__6eY-5"};